import { getBuyButtonConfig } from '../utils/commonEntitlements';

export const NEXT_INSURANCE_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.nextInsurance.buyBox.bulletPoint1' },
          { title: 'productPage.nextInsurance.buyBox.bulletPoint2' },
          { title: 'productPage.nextInsurance.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.nextInsurance.buyBox.productName',
        veloCta: {
          displayVeloCta: true,
          promptMessageId: 'productPage.nextInsurance.buyBox.veloCta.prompt',
          topic: 'small-business-insurance',
        },
        interactService: {
          service: 'next_insurance',
          openInNewTab: true,
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/home-repair-phone.png',
      alt: 'productPage.nextInsurance.heroPicture.altText',
    },
    headline: 'productPage.nextInsurance.page.headline',
    partnerLogo: {
      src: '/s2/vector/partnership-next.svg',
      alt: '',
    },
    partnerReviewBlanks: [
      {
        text: 'productPage.nextInsurance.page.reviewText1',
      },
      {
        src: '/illustration/trustpilot-4.5-star.svg',
        showOnMobile: true,
        alt: '',
      },
      {
        src: '/illustration/trustpilot-logo.svg',
        alt: '',
      },
    ],
    subheader: 'productPage.nextInsurance.page.subheader',
  },
  benefit: {
    title: 'productPage.nextInsurance.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/gppgoodrounded.svg',
        title: 'productPage.nextInsurance.valueProp.propTitle1',
        description: 'productPage.nextInsurance.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/groupsrounded.svg',
        title: 'productPage.nextInsurance.valueProp.propTitle2',
        description: 'productPage.nextInsurance.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/gavelrounded.svg',
        title: 'productPage.nextInsurance.valueProp.propTitle3',
        description: 'productPage.nextInsurance.valueProp.shortCopy3',
      },
      {
        icon: '/s2/material-icons/directionscarrounded.svg',
        title: 'productPage.nextInsurance.valueProp.propTitle4',
        description: 'productPage.nextInsurance.valueProp.shortCopy4',
      },
      {
        icon: '/s2/material-icons/constructionrounded.svg',
        title: 'productPage.nextInsurance.valueProp.propTitle5',
        description: 'productPage.nextInsurance.valueProp.shortCopy5',
      },
      {
        icon: '/s2/material-icons/homeworkrounded.svg',
        title: 'productPage.nextInsurance.valueProp.propTitle6',
        description: 'productPage.nextInsurance.valueProp.shortCopy6',
      },
    ],
  },
  highlight: {
    icon: '/s2/material-icons/checkcirclerounded.svg',
    title: 'productPage.nextInsurance.topFeature.title',
    subheader: 'productPage.nextInsurance.topFeature.subheader',
    image: '/s2/raster/barber-shave-customer.png',
    alt: 'productPage.nextInsurance.topFeature.altText',
  },
  howItWorks: {
    title: 'productPage.nextInsurance.howItWorks.title',
    items: [
      {
        title: 'productPage.nextInsurance.howItWorks.step1',
      },
      {
        title: 'productPage.nextInsurance.howItWorks.step2',
      },
      {
        title: 'productPage.nextInsurance.howItWorks.step3',
      },
    ],
    image: '/s2/raster/couple-owners-restaurant.png',
    alt: 'productPage.nextInsurance.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  assistance: {
    title: 'productPage.nextInsurance.needAssistance.title',
    getInTouch: 'productPage.nextInsurance.needAssistance.getInTouch',
    actions: 'productPage.nextInsurance.needAssistance.actions',
  },
  getBuyButtonConfig: (entitlements, service) =>
    getBuyButtonConfig({
      entitlements,
      service,
      ctaText: 'productPage.nextInsurance.buyBox.buttonLabel',
    }),
};
